var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMute = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.52 2.35998L8.66667 5.99998H5.5C4.67157 5.99998 4 6.67156 4 7.49998V12.5C4 12.9889 4.23389 13.4231 4.59588 13.697L5.32454 12.9683C5.13495 12.8973 5 12.7144 5 12.5V7.49998C5 7.22384 5.22386 6.99998 5.5 6.99998H8V10.2929L9 9.29288V7.24998C9 7.0926 9.0741 6.94441 9.2 6.84998L12.84 4.11998C12.9059 4.07054 13 4.11758 13 4.19998V5.29288L14 4.29288V2.59998C14 2.35277 13.7178 2.21165 13.52 2.35998ZM14 5.70709L13 6.70709V15.8C13 15.8824 12.9059 15.9294 12.84 15.88L9.2 13.15C9.0741 13.0556 9 12.9074 9 12.75V10.7071L8 11.7071V13H6.70711L5.70711 14H8.66667L13.52 17.64C13.7178 17.7883 14 17.6472 14 17.4V5.70709Z",
  fill: "#909797"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7071 2.29289C19.0976 2.68342 19.0976 3.31658 18.7071 3.70711L4.70711 17.7071C4.31658 18.0976 3.68342 18.0976 3.29289 17.7071C2.90237 17.3166 2.90237 16.6834 3.29289 16.2929L17.2929 2.29289C17.6834 1.90237 18.3166 1.90237 18.7071 2.29289Z",
  fill: "#909797"
})));
export default SvgMute;